<template>
  <div class="primaryOrder">
    <base-list-management
      ref="baseListManagement"
      :configData.sync="c_primaryOrderConfigData"
      >
      <PublicExport
        slot="custom-export"
        v-if="judgePermission('for_rent_sign_contract_ent_rent_order_main_export')"
        exportTitle="导出"
        exportTemplate="LeaseOrder"
        :getSearchData="searchParams"
        templateCode="vehicle-workbench-ent-rent-order"
        :getSearchCondition="getSearchCondition"
      />
      <div slot="custom-operate">
        <el-button
          type="primary"
          size="small"
          class="whole_contract_btn"
          v-if="judgePermission('for_rent_sign_contract_ent_rent_order_sub_add_car')"
          @click="enterSign"
          >企业签约提车
        </el-button>
        <el-button
          v-if="judgePermission('for_rent_sign_contract_ent_rent_order_main_import')"
          type="primary"
          size="small"
          @click="initOrder"
          >
          初始化历史企业租赁订单
        </el-button>
      </div>
    </base-list-management>
    <dialog-wrap-upgrade
      ref="batchImport"
      :configOptions="configOptions"
      >
      <template #uploadMain>
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({file}) => uploadRequest(file, 37)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
          >
          <el-button size="small" type="primary">初始化主订单</el-button>
        </el-upload>
      </template>
      <template #uploadVice >
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({file}) => uploadRequest(file, 38)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
          >
          <el-button size="small" type="primary">初始化在租子订单</el-button>
        </el-upload>
      </template>
      <template #uploadReturn >
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({file}) => uploadRequest(file, 39)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
          >
          <el-button size="small" type="primary">初始化已退子订单</el-button>
        </el-upload>
      </template>
    </dialog-wrap-upgrade>
  </div>
</template>
<script>
// api
import { closeEnterpriseOrder } from '@/api/purchaseAndSaleAPI'
import { uploadTaskCreate } from '@/api/currencyApi.js'
import { searchByCustomerName } from '@/api/domain/customers'
// 配置
// eslint-disable-next-line import/no-cycle
import config from '../config'
import { entLeaseOrderTemplate, entLeaseSubOrderTemplate, entLeaseReutrnSubOrderTemplate } from '@/config'
import { getHead } from '@/utils'
import axios from 'axios'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  data() {
    const {
      c_primaryOrderConfigData,
    } = config.call(this)
    return {
      c_primaryOrderConfigData,
      fileList: [],
      uploadCode: {
        37: 'order_renting_master_file',
        38: 'order_renting_son_file',
        39: 'order_renting_son_file',
      },
      // c_primaryOrderConfigData有引用
      // eslint-disable-next-line vue/no-unused-properties
      customerConditionList: [],
    }
  },
  computed: {
    // 导入功能弹框配置信息
    configOptions() {
      return {
        attrs: {
          title: '初始化历史企业租赁订单',
          width: '1000px',
        },
        contentConfig: {
          title:
            '此功能用于批量初始化历史「企业租赁订单-主订单」和「企业租赁订单-子订单」这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，请单击 下载模板 下载Excel标准模板。',
          describes: [
            '导入前准备：',
            '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板的原有内容，建议重新下载模板；',
            '2.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
            '3.确保excel中数据格式正确。',
            '4.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
          ],
        },
        footerList: [
          { slotName: 'uploadMain' },
          {
            text: '主订单模板下载',
            isShowBtn: true,
            click: () => {
              window.location.href = entLeaseOrderTemplate
            },
            options: {},
          },
          { slotName: 'uploadVice' },
          {
            text: '在租子订单模板下载',
            isShowBtn: true,
            click: () => {
              window.location.href = entLeaseSubOrderTemplate
            },
            options: {},
          },
          { slotName: 'uploadReturn' },
          {
            text: '已退子订单模版下载',
            isShowBtn: true,
            click: () => {
              window.location.href = entLeaseReutrnSubOrderTemplate
            },
            options: {},
          },
        ],
      }
    },
  },
  methods: {
    // 客户模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    customerRemoteMethod(query) {
      if (query.length >= 1) {
        searchByCustomerName({
          customerState: 1,
          customerType: 2,
          customerName: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'customerId',
            data,
          })
        })
      }
    },
    // 初始化历史企业租赁订单
    initOrder() {
      this.$refs.batchImport.showDialog()
    },
    /* 自定义上传 */
    uploadRequest(file, uploadType) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'order')
      formData.append('code', this.uploadCode[uploadType])
      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...getHead(this.$store),
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            uploadTaskCreate({
              uploadType, // 37 企业租赁订单导入 38 企业租赁子订单导入 39 初始化退车子订单
              fileAddress: data,
              fileName: file.name,
            })
              .then((res) => {
                if (res.code === 1) {
                  this.$message({
                    message: '导入成功',
                    type: 'success',
                  })
                  this.$refs.batchImport.close()
                }
              })
              .catch((error) => { console.log('err', error) })
            this.fileList = []
          } catch (error) {
            this.fileList = []
          }
        } else {
          this.fileList = []
          this.$message.error(msg)
        }
      }).catch(() => {
        this.fileList = []
      })
    },
    enterSign() {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
      })
    },
    // 订单关闭
    // eslint-disable-next-line vue/no-unused-properties
    getVoidComplete(item) {
      // // 订单状态「待确认」「进行中」「已完成」
      this.$confirm('请确认是否关闭订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { id } = item
        const res = await closeEnterpriseOrder({ id })
        if (res.code === 1) {
          this.$message({
            type: 'success',
            message: '关闭成功!',
          })
          this.$refs.baseListManagement.searchForm()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        })
      })
    },
    // 点击跳转新增车辆页面
    // eslint-disable-next-line vue/no-unused-properties
    handleAddCarClick(rowData) {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query: {
          stepActive: 1,
          entRentOrderId: rowData.id,
          customerName: rowData.customerName,
          customerId: rowData.customerId,
          deptId: rowData.deptId,
        },
      })
    },
    // 详情页
    // eslint-disable-next-line vue/no-unused-properties
    handleOrderDetail(id) {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterprisePrimaryDetail',
        query: { id },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      return {
        ...val,
        stateList: [1, 2], // 主订单状态列表 1已创建/2进行中/3已关闭
        createStartTime: val.startTime ? val.startTime?.[0] : '',
        createEndTime: val.startTime ? val.startTime?.[1] : '',
      }
    },
    searchParams() {
      return this.$refs.baseListManagement?.getParams() || {}
    },
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = this.c_primaryOrderConfigData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        if (key === 'customerId') {
          item.elConfig.options.list = this.customerConditionList
        }
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      // Tab需要放入导出的查询条件中
      conditions.push({
        label: '订单类型',
        matchValue: '企业租赁主订单',
      })
      return conditions
    },
  },
}
</script>
